export class CreateConnectorInputAwsAccountProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "discoveryRoleName",
            "baseName": "discoveryRoleName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dataAccessRoleName",
            "baseName": "dataAccessRoleName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateConnectorInputAwsAccountProperties.attributeTypeMap;
    }
    constructor() {
    }
}
